import { COURSES_API } from 'modules/courses/courses/api/courses-api'
import { CourseFilterInterface } from 'modules/courses/courses/types/course-filter-interface'
import { CourseApiInterface } from 'modules/courses/courses/types/course-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { SwrPaginationInterface } from 'shared/types/pagination-interface'
import { getPaginationQueryString } from 'shared/utils/api/get-pagination-query-string'
import { baseFetcher } from 'shared/utils/http-client'
import { coursesDependencies } from '../../constants/courses-dependencies'

interface UseCoursesInterface extends SwrPaginationInterface {
  filter: CourseFilterInterface
}
export function useCourses({ limit, pagination, filter }: UseCoursesInterface) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, CourseApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const filterApi = `${
    filter.search !== '' ? `&filter[searchBy]=${encodeURIComponent(filter.search)}` : ''
  }${filter.status !== undefined ? `&filter[isActive]=${filter.status}` : ''}`

  const { data: courses, mutate } = useControlledSwr(
    () => [
      `${COURSES_API}/list?${getPaginationQueryString({ limit, pagination })}${filterApi}`,
      ...coursesDependencies,
    ],
    fetcher,
    undefined,
    !!user,
  )

  const { data: counter } = useControlledSwr(() => {
    if (user) {
      return [`${COURSES_API}/count?pagination[limit]${filterApi}`, ...coursesDependencies]
    }
    return null
  }, baseFetcher)

  return { courses, mutate, counter }
}
